import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS, SAGE_DOMAINES_OPTIONS, SAGE_DOMAINE, SAGE_TYPES_DOCUMENTS_OPTIONS, SAGE_TYPE_DOCUMENT } from 'src/app/app.models';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';

export enum Enum_SoudotecInventoryInputModeScan {
	FAMOCO_SCAN_LASER = 0,
	QRCODE_READER = 1,
	NEWLAND_SCANNER = 2,
}
  
export interface InventoryInputModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE; 
	modeScan: Enum_SoudotecInventoryInputModeScan; 
}
  
export class InventoryInputModel extends DynamicInputModel {
	@serializable() readonly type: string = 'soudotec_inventory_input';
	componentMode: COMPONENT_MODE;
	modeScan: Enum_SoudotecInventoryInputModeScan;
	constructor(config: InventoryInputModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.modeScan = config.modeScan;
	}

	static initModel(_component: any): InventoryInputModel {
		const formModel = new InventoryInputModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS,
			modeScan: _component.MODE_SCAN,
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		const workflowSteps = !!_options && !!_options.workflow ? _options.workflow.WORKFLOW_STEPS.map(step => ({ ID: step.NUM_WORKFLOWSTEP, TEXT: `${step.INDEX_WORKFLOWSTEP} - ${step.TITRE}` })) : [];
		const workflowComponents = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]`, NUMWORKFLOW_STEP: step.NUM_WORKFLOWSTEP })))) : [];
		
		return {
			ID: 'soudotec_inventory_input',
			CODE: CODE_WORKFLOW_COMPONENT.SOUDOTEC_INVENTORY_INPUT,
			ICON: 'duplicate-outline',
			LABEL: 'Saisie d\'inventaire',
			HAS_DATASOURCE: true,
			CODE_SOCIETE: 'SOUDOTEC',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
                { ID: 'NUM_DATASOURCE', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Source de données', IS_REQUIRED: true },
                { ID: 'VALUE_COLUMN_NAME', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Colonne Valeur', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				{ ID: 'DISPLAY_COLUMN_NAME', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Colonne Affichage', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				{ ID: 'QRCODE_COLUMN_NAME', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Colonne QRCode', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				{ ID: 'MODE_SCAN', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Mode Scan', DEFAULT_VALUE: Enum_SoudotecInventoryInputModeScan.FAMOCO_SCAN_LASER, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [
								{ ID: Enum_SoudotecInventoryInputModeScan.FAMOCO_SCAN_LASER, TEXT: 'Famoco Scan Laser' }, 
								{ ID: Enum_SoudotecInventoryInputModeScan.QRCODE_READER, TEXT: 'Lecteur QRCode' },
								{ ID: Enum_SoudotecInventoryInputModeScan.NEWLAND_SCANNER, TEXT: 'Newland Scanner' },
							],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ ID: 'GRID_COLUMNS', CODE: CODE_WORKFLOW_COMPONENT.INPUT_GRID_COLUMNS_BUILDER, LABEL: 'Colonnes', IS_VISIBLE: false, DEFAULT_VALUE: [
					{ ID: 'AR_Ref', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Référence Article' },
					{ ID: 'AR_Design', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Désignation Article' },
					{ ID: 'ABW_CodeScanned', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Code Scanné' },
					{ ID: 'ABW_QuantiteSaisie', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Quantité saisie' },
				] },
			]
		};
	}
}
  